// @TODO: should be undefined for standalone simulations
export const ExerciseWithStandaloneSimulation = '00000000-0000-0000-0000-000000000000';
